@use "Styles/includes/variables";
@use "Styles/mixins" as mixins;

:host {
    box-sizing: border-box;
    line-height: 1;
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: variables.$fontQuaternary;

    width: 100vw;
    margin-left: calc(50% - 50vw);
    padding-inline: 16px;
    overflow-x: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }

    @include mixins.desktop-and-up {
        width: auto;
        margin-left: 0;
        padding-inline: 0;
        overflow-x: visible;
    }
}

:host > * {
    flex-shrink: 0;
}

*,
*::before,
*::after {
    box-sizing: inherit;
}
